import { useNavigate } from 'react-router-dom'

const ITEMS = [
  { label: 'Cliente', desc: 'Pessoa física ou jurídica contratante', path: '/clientes', icon: '👤', color: '#60a5fa' },
  { label: 'Contrato', desc: 'Contrato vinculado ao cliente', path: '/clientes', icon: '📄', color: '#a78bfa' },
  { label: 'Unidade', desc: 'Filial ou unidade de negócio', path: '/obras', icon: '🏢', color: '#34d399' },
  { label: 'Obra', desc: 'Empreendimento ligado ao contrato', path: '/obras', icon: '🏗️', color: '#fbbf24' },
  { label: 'Centro de Custo', desc: 'Divisão de custo dentro da obra', path: '/obras', icon: '📂', color: '#f87171' },
  { label: 'Fornecedor', desc: 'Prestador de serviço ou material', path: '/fornecedores', icon: '🏭', color: '#fb923c' },
  { label: 'Categoria Orç.', desc: 'Grupo orçamentário de itens', path: '/categorias', icon: '🏷️', color: '#e879f9' },
  { label: 'Cargo / Função', desc: 'Cargos e funções para colaboradores', path: '/colaboradores', icon: '👷', color: '#2dd4bf' },
  { label: 'Faixa de Custo', desc: 'Referência de custo por cargo', path: '/colaboradores', icon: '💰', color: '#facc15' },
  { label: 'Colaborador', desc: 'Profissional alocado à obra', path: '/colaboradores', icon: '👥', color: '#4ade80' },
]

export default function Cadastros() {
  const navigate = useNavigate()
  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <h1 style={{ color: '#f7f8f8', fontSize: 18, fontWeight: 600 }}>Cadastros</h1>
        <p style={{ color: '#62666d', fontSize: 13, marginTop: 2 }}>Acesso rápido aos principais cadastros mestres do sistema.</p>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 12 }}>
        {ITEMS.map(item => (
          <button
            key={item.label}
            onClick={() => navigate(item.path)}
            style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 8, padding: '16px', textAlign: 'left', cursor: 'pointer', transition: 'border-color 0.15s, background 0.15s' }}
            onMouseEnter={e => { (e.currentTarget as HTMLButtonElement).style.background = 'rgba(255,255,255,0.04)'; (e.currentTarget as HTMLButtonElement).style.borderColor = 'rgba(255,255,255,0.14)' }}
            onMouseLeave={e => { (e.currentTarget as HTMLButtonElement).style.background = 'rgba(255,255,255,0.02)'; (e.currentTarget as HTMLButtonElement).style.borderColor = 'rgba(255,255,255,0.08)' }}
          >
            <span style={{ fontSize: 24, marginBottom: 10, display: 'block' }}>{item.icon}</span>
            <p style={{ color: item.color, fontSize: 14, fontWeight: 600, marginBottom: 4 }}>{item.label}</p>
            <p style={{ color: '#62666d', fontSize: 12 }}>{item.desc}</p>
          </button>
        ))}
      </div>
    </div>
  )
}

